import {Campaign} from '../../../model/campaign/Campaign';
import {BaseModel} from '../../../model/shared/BaseModel';
import {requests} from '../../../utils';
import {AGENCY_INVOICE} from '../../../utils/endpoints';
import {IDashboardPagination} from '../../influencer/dashboard/dto/IDashboard';

export const AgencyInvoicesService = {
    getDropdownCampaigns: (selectedUserId: number, params?: IDashboardPagination,): Promise<BaseModel<Campaign[]>> => requests.get(`${AGENCY_INVOICE}/dropdown/campaigns/${selectedUserId}`, params),
    getInvoiceArchive: (selectedUserId: number, params?: IDashboardPagination,): Promise<BaseModel<Campaign[]>> => requests.get(`${AGENCY_INVOICE}/archive/${selectedUserId}`, params),
}